export default function PartnerLogos() {
  const LogoContainer = ({ children, name }) => (
    <div className="flex items-center gap-2 opacity-50 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0 cursor-default group">
      {children}
      <span className="font-heading font-bold text-lg text-[var(--text-main)] group-hover:text-[var(--nily-teal)] transition-colors">{name}</span>
    </div>
  );

  return (
    <div className="flex gap-12 items-center">
      {/* 1. Academic Partner */}
      <LogoContainer name="Stanford Med">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--text-main)]">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      </LogoContainer>

      {/* 2. Clinical Partner */}
      <LogoContainer name="NIMHANS">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--text-main)]">
          <path d="M12 2a10 10 0 1 0 10 10H12V2z" />
          <path d="M12 12 2.1 12a10.1 10.1 0 0 0 9.9 9.9V12z" />
        </svg>
      </LogoContainer>

      {/* 3. Standard Body */}
      <LogoContainer name="ISO 27001">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--text-main)]">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </LogoContainer>

      {/* 4. Health Body */}
      <LogoContainer name="NHS Digital">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--text-main)]">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      </LogoContainer>

      {/* 5. Association */}
      <LogoContainer name="APA">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[var(--text-main)]">
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <line x1="9" y1="9" x2="9.01" y2="9" />
          <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
      </LogoContainer>
    </div>
  );
}
